function isEven(value: number) {
  return value % 2 === 0;
}

export { isEven };
